<script lang="ts">
import { ISwitchState } from '@/components/atoms/form/switch/switch-state.interface';
import Switch from '@/components/atoms/form/switch/Switch.vue';
import IconComponent from '@/components/atoms/Icon.vue';
import { IIconNoticeState } from '@/components/molecules/notices/icon-notice/icon-notice-state.interface';
import { IconNoticeType } from '@/components/molecules/notices/icon-notice/icon-notice-type.definition';
import { ObjectUtils } from 'webshop-modules';
import {Component, Vue, Emit, Prop} from "vue-facing-decorator"

@Component({
    components: {
        IconComponent,
        Switch,
    },
    name: 'IconNotice'
})
export default class IconNotice extends Vue {
    @Prop() 
    public state!: IIconNoticeState;

    @Emit() 
    public stateChange(update: IIconNoticeState): IIconNoticeState { return update; }

    public readonly IconNoticeType: typeof IconNoticeType = IconNoticeType;

    public handleChangeOf(switchState: ISwitchState): void {
        const update = ObjectUtils.clone(this.state);
        update.switchState = switchState;
        this.stateChange(update);
    }
}
</script>

<template>
    <div class="m-iconNotice" v-bind:class="{
        '-is-interactive': state.hasSwitch,
        '-active': state.switchState?.state,
        '-error': state.type === IconNoticeType.Error,
        '-success': state.type === IconNoticeType.Success,
        '-warning': state.type === IconNoticeType.Warning,
    }">
        <div class="m-iconNotice__block">
            <IconComponent class="m-iconNotice__icon" :iconId="state.icon"></IconComponent>
            <div class="m-iconNotice__textblock">
                <slot></slot>
            </div>
        </div>

        <div v-if="state.hasSwitch" class="m-iconNotice__switch">
            <Switch :state="state.switchState"
                @state-change="handleChangeOf($event)"
            ></Switch>
        </div>
    </div>
</template>
